<div class="p-0">
    <app-new-map
        [latitud] = lat
        [longitud] = lng
        [direccion] = dir
        [height]= height>
    </app-new-map>
</div>